/* global window */
import React from 'react';
import Isvg from 'react-inlinesvg';
import { cloneDeep } from 'lodash';
import StudentsIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_student-management.svg';
import ExpandIcon from '../assets/images/expand.svg';
import MinimiseIcon from '../assets/images/minimize.svg';
import css from '../containers/class-details/class-details.scss';
import {
    BASE_COL_CONFIG,
    BASE_COL_GROUP, BASE_TOTAL_CERTIFICATES_COL, BASE_TOTAL_CERTIFICATES_COLGROUP,
    NEW_CERT_COL,
    NEW_CERT_COL_EXPANDED, NEW_CERT_COL_GROUP, NEW_CERT_COL_GROUP_EXPANDED, PAST_CERT_COL,
    PAST_CERT_COL_EXPANDED, PAST_CERT_COL_GROUP, PAST_CERT_COL_GROUP_EXPANDED
} from '../containers/class-details/class-details-constants';
import IconMessage from '../components/icon-message/icon-message';

export const locale = () => {
    const query = window.location.search.slice(1);
    const match = query.match(/\blocale=([-a-zA-Z]+)\b/);
    return match ? match[1] : 'en-AU';
};

export const translateTableLabels = (tableConfig, localeData, isUpperCase = false, fullTotal = null) => {
    function translateName(col) {
        if (col.trans) {
            const isNotUppercase = col.case === 'lower';
            let name = localeData[col.trans];
            if (name) {
                if (isNotUppercase) {
                    col.name = name;
                } else {
                    name = isUpperCase ? name.toUpperCase() : name;
                    col.name = name;
                }
            }
        }
    }
    const { cols, colGroups } = tableConfig;
    const { emptyDataMessage } = tableConfig;
    cols.forEach(col => translateName(col));

    if (colGroups) {
        colGroups[0].forEach((col) => {
            translateName(col);
        });
    }
    const totalColConfig = tableConfig.cols.find(col => col.id === 'total');
    if (totalColConfig) {
        totalColConfig.name = fullTotal ? `${totalColConfig.name} (${fullTotal})` : totalColConfig.name;
    }

    if (emptyDataMessage) {
        tableConfig.emptyDataMessage = localeData[emptyDataMessage];
    }
    return tableConfig;
};

export const addClickFn = (col, manageCertificateTypeDisplay) => {
    const isExpanded = col.expanded;
    const btnText = isExpanded ? 'Collapse' : 'Expand';
    col.headerTransform = () => (
        <div
            className={css['header-content']}
            onClick={() => manageCertificateTypeDisplay(col)}
            role={'button'}
            tabIndex={-1}
        >
            {col.name}
            <div className={css['header-btn']}>
                <div className={css.content}>
                    { isExpanded && <Isvg src={MinimiseIcon} cacheGetRequests />}
                    {btnText}
                    { !isExpanded && <Isvg src={ExpandIcon} cacheGetRequests />}
                </div>
            </div>
        </div>
    );
};

export const checkForHeaderBtn = (tableConfig, manageCertificateTypeDisplay) => {
    const { colGroups } = tableConfig;
    if (colGroups) {
        colGroups[0].forEach((col) => {
            if (col.hasHeaderBtn) {
                addClickFn(col, manageCertificateTypeDisplay);
            }
        });
    }

    return tableConfig;
};

export const getConfig = ({ newCertExpanded, pastCertExpanded, localeData, callback, emptyDataText }) => {
    const newCertCols = newCertExpanded ? NEW_CERT_COL_EXPANDED : NEW_CERT_COL;
    const pastCertCols = pastCertExpanded ? PAST_CERT_COL_EXPANDED : PAST_CERT_COL;
    const newCertColGroups = newCertExpanded ? NEW_CERT_COL_GROUP_EXPANDED : NEW_CERT_COL_GROUP;
    const pastCertColGroups = pastCertExpanded ? PAST_CERT_COL_GROUP_EXPANDED : PAST_CERT_COL_GROUP;
    let tableConfig = {
        cols: [
            ...cloneDeep(BASE_COL_CONFIG),
            ...cloneDeep(newCertCols),
            ...cloneDeep(pastCertCols),
            ...cloneDeep(BASE_TOTAL_CERTIFICATES_COL)
        ],
        colGroups: [[
            ...cloneDeep(BASE_COL_GROUP),
            ...cloneDeep(newCertColGroups),
            ...cloneDeep(pastCertColGroups),
            ...cloneDeep(BASE_TOTAL_CERTIFICATES_COLGROUP)
        ]]
    };
    const isUpperCase = true;
    tableConfig = translateTableLabels(tableConfig, localeData, isUpperCase);
    tableConfig = checkForHeaderBtn(tableConfig, callback);
    tableConfig.emptyDataMessage = <IconMessage iconSrc={StudentsIcon} message={emptyDataText} />;
    return tableConfig;
};



// WEBPACK FOOTER //
// ./locale/locale-utils.js